import { render, staticRenderFns } from "./LoadingCircle.vue?vue&type=template&id=ed636308&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed636308')) {
      api.createRecord('ed636308', component.options)
    } else {
      api.reload('ed636308', component.options)
    }
    module.hot.accept("./LoadingCircle.vue?vue&type=template&id=ed636308&", function () {
      api.rerender('ed636308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/animations/LoadingCircle.vue"
export default component.exports